import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H3, H5 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { BlockContainer, FullWidthListContainer, IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { appsData } from './data';

import * as ST from './styled';

const Apps = () => {
    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);

    return (
        <BlockContainer indent={{ $mobile: [24, 16], $desktop: [32, 24] }} rounder={{ $radius: 32 }} bgColor={COLORS.BgMain}>
            <IndentContainer $united={[0, 8]}>
                <H3>Три приложения для управления сервисами от&nbsp;Дом.ру</H3>
            </IndentContainer>
            <ListContainer data-test='apps-container' $size={12} $direction='column'>
                {appsData.map(({ id, title, text, imgLogo, imgLogoAlt, imgQr, imgQrAlt, btnLink }) => (
                    <ST.AppCard key={id} >
                        <BlockContainer indent={{ $mobile: [16], $desktop: [24] }} rounder={{ $radius: 24 }}>
                            {isTablet
                                ? <>
                                    <FullWidthListContainer $size={16} $wrap='nowrap' $alignItems='center'>
                                        <ST.ImageWrapper $size={64}>
                                            <img src={imgLogo} alt={imgLogoAlt} />
                                        </ST.ImageWrapper>
                                        <H5 $withIndent={false}>{title}</H5>
                                    </FullWidthListContainer>
                                    <IndentContainer $united={[12, 0, 16]}>
                                        <Paragraph4 dangerouslySetInnerHTML={{ __html: text }} />
                                    </IndentContainer>
                                    <ButtonGroup>
                                        <a href={btnLink} target='_blank' rel='noopener noreferrer'>
                                            <Button bType='secondary'>Скачать приложение</Button>
                                        </a>
                                    </ButtonGroup>
                                </>
                                : <ListContainer data-test='desktop-card' $size={16} $wrap='nowrap'>
                                    <ST.ImageWrapper $size={64}>
                                        <img src={imgLogo} alt={imgLogoAlt} />
                                    </ST.ImageWrapper>
                                    <div>
                                        <H5 $withIndent={false}>{title}</H5>
                                        <Paragraph4 dangerouslySetInnerHTML={{ __html: text }} />
                                    </div>
                                </ListContainer>}
                        </BlockContainer>
                        <BlockContainer indent={{ $mobile: [16], $desktop: [24] }} rounder={{ $radius: 24 }}>
                            <ListContainer $size={16} $wrap='nowrap'>
                                <ST.ImageWrapper $size={96}>
                                    <img src={imgQr} alt={imgQrAlt} />
                                </ST.ImageWrapper>
                                <div>
                                    <H5 $withIndent={false}>{title}</H5>
                                    <Paragraph4>Отсканируйте qr-код и&nbsp;скачайте приложение</Paragraph4>
                                </div>
                            </ListContainer>
                        </BlockContainer>
                    </ST.AppCard>
                ))}
            </ListContainer>
        </BlockContainer >
    );
};

export default Apps;
